/**
 * Manager for semantic tags related to Warehouse assets (fixture, material, etc..).
 *
 * Created by Alex Bouenard, alexandre@modsy.com, December 2020.
 *
 * Copyright (c) 2020 Pencil + Pixel, Inc. All rights reserved.
 */

import CoreUtils from 'shared/libraries/mwc/utils/coreUtils';

export default class TagManager {
    protected static getTagsArray(tags: any) {
        if (!tags) {
            return [];
        }
        let tagsArray = [];
        if (typeof (tags) === 'string') {
            tagsArray = CoreUtils.replaceAll(tags, ',', '').split(' ');
        } else if (typeof (tags) === 'object') {
            tagsArray = tags.slice(0);
        }
        return tagsArray.map(strTag => strTag.toLowerCase());
    }

    static hasTag(tags: any, searchTag: string, searchWithinEachTag = false): boolean {
        const tagsArray = TagManager.getTagsArray(tags);
        const searchCompatibleTag = searchTag.toLowerCase();
        if(tagsArray.indexOf(searchCompatibleTag) >= 0)
            return true;

        if(searchWithinEachTag)
		{
            for(let strTag of tagsArray)
			{
                if(strTag.indexOf(searchTag) >= 0)
                    return true;
			}
		}

        return false;
    }
}